/**
 * noticePreviewModule 通知公告详情的弹框
 * author: tanyaohua
 */
'use strict';
angular.module('noticePreviewModule', []).controller('noticePreviewCtrl', [
    '$scope',
    '$q',
    'iwoNoticeService',
    '$modalInstance',
    '$filter',
    'modalDialog',
    'params',
    'ismanage',
    function($scope, $q, iwoNoticeService, $modalInstance, $filter, modalDialog, params, ismanage) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = params;
            $scope.isManage = ismanage;
        }

        /**
         * [initData description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            // 请求数据方法
            getNoticeDetail();
        }

        /**
         * [getNoticeDetail description]请求详情页接口
         *
         * @return  {[type]}  [return description]
         */
        function getNoticeDetail() {
            let defer = $q.defer();
            let params = {
                // serviceid: 'notice',
                // method: 'noticeDetial',
                noticeid: $scope.data.noticeid,
            };

            iwoNoticeService.initEditData(params).then((data) => {
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                } else {
                    $scope.data.noticeInfo = data.data;
                    $scope.data.noticeInfo.appendixinfo = $scope.data.noticeInfo.appendixs.map((_item) => ({
                        FileSize: _item.filesize,
                        FileDesc: _item.filedesc,
                        FileName: _item.filename,
                    }));
                    if ($scope.data.noticeInfo.alluser) {
                        $scope.data.noticeInfo.newgroups = '全部';
                        // $scope.data.noticeInfo.newgroups = '全部人员';
                    } else {
                        if (data.data.users) {
                            $scope.data.noticeInfo.newgroups = data.data.users
                                .map((i) => i.TRUENAME)
                                .join('，');
                        }
                        if (data.data.groups) {
                            $scope.data.noticeInfo.newgroups = data.data.groups
                                .map((i) => i.GNAME)
                                .join('，');
                        }
                        if (data.data.newgroups) {
                            $scope.data.noticeInfo.newgroups = data.data.newgroups
                                .map((i) => i.LABELNAME)
                                .join('，');
                        }
                    }

                    defer.resolve();
                }
            });
            return defer.promise;
        }

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [downloadFile description]  附件栏目，文件下载
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.downloadFile = function(item) {
            var $a = $(document.createElement('a'));
            $a.attr({
                href: '/message/notice/downFile?filename=' + item.FileName,
                download: item.FileName,
            });
            $a[0].click();
        };

        $scope.getFileType = function(name) {
            name = name.toLowerCase();
            if (/\.(gif|jpg|jpeg|png)$/.test(name)) {return 'icon-noticetupian1';}
            if (/\.(doc|docx|xls|xlsx|pdf|pptx)$/.test(name)) {return 'icon-noticewendang';}
            if (/\.(mp4|avi|wmv|mpeg|mov|rmvb)$/.test(name)) {return 'icon-noticeshipin';}
            if (/\.(mp3|wma|rmvb|flv|mpg)$/.test(name)) {return 'icon-noticeyinpin1';}
            if (/\.(rar|zip|arj|gz|winzip|z)$/.test(name)) {return 'icon-yunpanlogo-';}
            return 'icon-noticewendang';
        };

        /**
         * [differenceType description]区分文件类型
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.differenceType = function(item) {
            var type = item.FileDesc.substring(item.FileDesc.lastIndexOf('.') + 1).toLowerCase();
            return $scope.status.fileType.indexOf(type) > -1 ? type : 'default';
        };
    },
]);
